(function ($, njm) {
    'use strict';

    njm.views.dataLayer = Backbone.View.extend({

        events: {
            'click [data-layer]:not(.disabled)': 'clickAction'
        },

        /**
         * Click Action
         * @param {Object} e
         */
        clickAction: function (e) {
            // check if dayaLayer available
            if (dataLayer) {
                // get the current event
                var event = $(e.currentTarget).data('layer');
                var params = this.parseDataLayer($(e.currentTarget).data());

                // execute action
                if (event) {
                    dataLayer.push(_.extend({ event: event }, params));
                }
            }
        },

        /**
         * Parse Daya Layer Attributes
         * @param data
         * @returns {{}}
         */
        parseDataLayer: function (data) {
            var newData = {};

            _.each(data, function (v, k) {
                var newKey = k.replace('layer', '');
                if (newKey) {
                    newData[k.replace('layer', '')] = v;
                }
            });

            return newData;
        }

    });
})(jQuery, njm);
